import type { DesignTemplateApi, DesignTemplateResponse } from './api'
import type { CoverDataType } from './constant'
import { CoverData, type CoverDataItem } from './CoverData/dto'

export class DesignTemplate<
  RequiredCoverData extends Record<
    keyof RequiredCoverData,
    CoverDataItem<CoverDataType, string> | null
  > = Record<string, CoverDataItem<CoverDataType, string> | null>,
> implements Omit<DesignTemplateResponse<RequiredCoverData>, 'coverData'>
{
  public id: number
  public categories: DesignTemplateResponse<RequiredCoverData>['categories']
  public color: DesignTemplateResponse<RequiredCoverData>['color']
  public coverData: CoverData<RequiredCoverData>
  public type: DesignTemplateResponse<RequiredCoverData>['type']
  public languageType: DesignTemplateResponse<RequiredCoverData>['languageType']
  public thumbnailImageUrl: string
  public pageSize = 100

  constructor(
    data:
      | DesignTemplate<RequiredCoverData>
      | (DesignTemplateResponse<RequiredCoverData> &
          Partial<Pick<DesignTemplate<RequiredCoverData>, 'pageSize'>>),
  ) {
    this.id = data.id
    this.categories = data.categories
    this.color = data.color
    this.coverData = new CoverData<RequiredCoverData>(data.coverData)
    this.type = data.type
    this.languageType = data.languageType
    this.thumbnailImageUrl = data.thumbnailImageUrl
    if (data.pageSize) {
      this.pageSize = data.pageSize
    }
  }

  setCoverData(coverData: CoverData<RequiredCoverData>) {
    this.coverData = coverData
  }

  toSummary(): DesignTemplateApi.Response.DesignTemplateSummary {
    if (this.languageType === 'KOREAN') {
      return {
        id: this.id,
        color: this.color,
        thumbnailImageUrl: this.thumbnailImageUrl,
        categories: this.categories,
        languageType: 'KOREAN',
        type: this.type as `K_${string}`,
      }
    } else {
      return {
        id: this.id,
        color: this.color,
        thumbnailImageUrl: this.thumbnailImageUrl,
        categories: this.categories,
        languageType: 'ENGLISH',
        type: this.type as `E_${string}`,
      }
    }
  }
}
